import { ApiResponse } from 'apisauce';

import { ApplicationReportStatusEnum } from '@/Modules/CustomersModule/shared/enums/customer-finance-application.enum';
import debugConfig from '@/shared/config/debug.config';
import api from '@/shared/config/http.config';
import { ErrorInfo } from '@/shared/interfaces/error-info.interface';
import { ResponseModel } from '@/shared/interfaces/response-model.interface';
import { FinanceApplicationsAgentReportModel } from '@/shared/models/finance-applications-agent-report.model';
import { FinanceApplicationsAgentStatusBreakdownModel } from '@/shared/models/finance-applications-agent-status-breakdown.model';
import { FinanceApplicationsFrequencyReportModel } from '@/shared/models/finance-applications-frequency-report.model';
import { FinanceApplicationsMerchantReportModel } from '@/shared/models/finance-applications-merchant-report.model';
import { FinanceApplicationsOverviewReportModel } from '@/shared/models/finance-applications-overview-report.model';
import { UserModel } from '@/shared/models/user.model';
import financeApplicationsFixtureService from '@/shared/services/fixtures/finance-applications/finance-applications-api.service';
import { DashboardReportScope } from '@/shared/types/shared-types/dashboard-report-scope.type';

const apis = {
  overviewReport: (
    startDate: string,
    endDate: string,
    financialMerchantId?: string[],
    assignedTo?: string[],
    scope?: DashboardReportScope
  ): Promise<ApiResponse<ResponseModel<FinanceApplicationsOverviewReportModel>, ErrorInfo>> =>
    api.post('/customerApplicationData/report/overview', {
      query: { startDate, endDate, financialMerchantId, assignedTo, ...scope }
    }),
  performanceReport: (
    startDate: string,
    endDate: string,
    applicationStatus: ApplicationReportStatusEnum,
    financialMerchantId?: string[],
    agentId?: string[],
    scope?: DashboardReportScope
  ): Promise<
    ApiResponse<ResponseModel<{ [key: string]: FinanceApplicationsAgentReportModel }>, ErrorInfo>
  > =>
    api.post('/customerApplicationData/report/agent', {
      query: {
        startDate,
        endDate,
        applicationStatus,
        financialMerchantId,
        agentId,
        ...scope
      }
    }),
  agentStatusBreakdownReport: (
    startDate: string,
    endDate: string,
    agentId?: string[],
    financialMerchantId?: string[],
    scope?: DashboardReportScope
  ): Promise<ApiResponse<ResponseModel<FinanceApplicationsAgentStatusBreakdownModel>, ErrorInfo>> =>
    api.post('/customerApplicationData/report/agent-status-breakdown', {
      query: {
        startDate,
        endDate,
        agentId,
        financialMerchantId,
        ...scope
      }
    }),
  merchantReport: (
    startDate: string,
    endDate: string,
    status: ApplicationReportStatusEnum,
    scope?: DashboardReportScope
  ): Promise<ApiResponse<ResponseModel<FinanceApplicationsMerchantReportModel[]>, ErrorInfo>> =>
    api.post('/customerApplicationData/report/merchant', {
      query: {
        startDate,
        endDate,
        applicationStatus: status,
        ...scope
      }
    }),
  getAllAgents: (): Promise<ApiResponse<ResponseModel<UserModel[]>, ErrorInfo>> =>
    api.get('/customerApplicationData/agents'),
  frequencyReport: (
    frequency: 'daily' | 'monthly' | 'yearly',
    metric: 'amount' | 'count',
    startDate: string,
    endDate: string,
    financialMerchantId?: string[],
    assignedTo?: string[],
    scope?: DashboardReportScope
  ): Promise<ApiResponse<ResponseModel<FinanceApplicationsFrequencyReportModel>, ErrorInfo>> =>
    api.post('/customerApplicationData/report/frequency', {
      query: {
        frequency,
        metric,
        startDate,
        endDate,
        financialMerchantId,
        assignedTo,
        ...scope
      }
    })
};

// TODO: Enhance the way of mocking APIs
export const financeApplicationsApi = debugConfig.useFixtures
  ? financeApplicationsFixtureService
  : apis;
